import {
  ArrowLeftRight,
  CalendarDays,
  ClipboardCheck,
  Inbox,
  Layers,
  Send,
  SlidersHorizontal,
  Smartphone,
} from "lucide-react";
import { useLayoutEffect } from "react";
import { applyTheme, getTheme } from "../../lib/theme";
import { LandingMotion } from "../marketing/LandingMotion";
import { CONTACT_EMAIL, MarketingFooter, MarketingHeader } from "../marketing/MarketingChrome";
import "../marketing/landing-palette.css";
import "../marketing/word-design.css";
import "./workflow-timeline.css";
import "./pricing.css";
export function PricingPage() {
  useLayoutEffect(() => {
    applyTheme("sage-clinic");
    return () => applyTheme(getTheme());
  }, []);
  return (
    <LandingMotion>
      <div data-la-root="" className="wt-page min-h-screen bg-bg">
        <div className="la-pinned-header">
          <div className="la-pinned-header-inner">
            <MarketingHeader />
          </div>
        </div>
        <main className="wt-main relative z-10">
          <div className="wt-intro">
            <h1>Plans &amp; pricing</h1>
            <p>We currently offer implementation through small-stage trials, by request.</p>
          </div>
          <div className="pricing-options">
            <section className="pricing-option" aria-labelledby="rostering-plan">
              <h2 id="rostering-plan">Rostering</h2>
              <p className="pricing-summary">
                For teams that want help building and managing their roster.
              </p>
              <ul>
                <li>
                  <SlidersHorizontal
                    aria-hidden="true"
                    className="pricing-feature-icon"
                    strokeWidth={1.75}
                  />
                  <span>
                    <strong>Your requirements</strong> - shifts, coverage, roles and workload rules
                  </span>
                </li>
                <li>
                  <CalendarDays
                    aria-hidden="true"
                    className="pricing-feature-icon"
                    strokeWidth={1.75}
                  />
                  <span>
                    <strong>Build the roster</strong> - propose assignments using your team's rules
                  </span>
                </li>
                <li>
                  <ClipboardCheck
                    aria-hidden="true"
                    className="pricing-feature-icon"
                    strokeWidth={1.75}
                  />
                  <span>
                    <strong>Review and adjust</strong> - check coverage and make changes before
                    publishing
                  </span>
                </li>
                <li>
                  <Send aria-hidden="true" className="pricing-feature-icon" strokeWidth={1.75} />
                  <span>
                    <strong>Publish the plan</strong> - share the roster when it's ready
                  </span>
                </li>
              </ul>
              <a
                className="pricing-contact"
                href={`mailto:${CONTACT_EMAIL}?subject=Tarii%20rostering%20trial`}
              >
                Email us for a free trial
              </a>
            </section>
            <section className="pricing-option pricing-option-full" aria-labelledby="member-plan">
              <h2 id="member-plan">Rostering &amp; member management</h2>
              <p className="pricing-summary">
                For teams that also want to manage day-to-day requests and keep members updated.
              </p>
              <ul>
                <li>
                  <Layers aria-hidden="true" className="pricing-feature-icon" strokeWidth={1.75} />
                  <span>
                    <strong>Everything in rostering</strong> - from setup to publication
                  </span>
                </li>
                <li>
                  <Inbox aria-hidden="true" className="pricing-feature-icon" strokeWidth={1.75} />
                  <span>
                    <strong>Leave and requests</strong> - members submit, rosterers review
                  </span>
                </li>
                <li>
                  <Smartphone
                    aria-hidden="true"
                    className="pricing-feature-icon"
                    strokeWidth={1.75}
                  />
                  <span>
                    <strong>Member rosters</strong> - published shifts on their phone
                  </span>
                </li>
                <li>
                  <ArrowLeftRight
                    aria-hidden="true"
                    className="pricing-feature-icon"
                    strokeWidth={1.75}
                  />
                  <span>
                    <strong>Swaps and updates</strong> - keep the team informed as the roster
                    changes
                  </span>
                </li>
              </ul>
              <a
                className="pricing-contact"
                href={`mailto:${CONTACT_EMAIL}?subject=Tarii%20member%20management%20trial`}
              >
                Email us for a free trial
              </a>
            </section>
          </div>
          <p className="pricing-note">Every part switches on or off for your team.</p>
          <p className="pricing-note">
            Contact us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> and we can arrange
            a free trial for your team according to your needs.
          </p>
          <MarketingFooter />
        </main>
      </div>
    </LandingMotion>
  );
}
